import { useQuizMetaContext } from '@mentimeter/quiz';
import type { LeaderboardStaticContent } from '@core-api/presentation/types/response';
import {
  usePresentationContext,
  usePresentationSlideContext,
} from '../../legacy-context/presentationContext';
import { ViewOnlyPresentationDataHandler } from './ViewOnlyPresentationDataHandler';
import { LivePresentationDataHandler } from './LivePresentationDataHandler';

export function QuizLeaderboardPresentationDataHandler() {
  const { useConfig } = usePresentationContext();
  const { leaderboardHasTimeBasedScoringBasedOnPreviousQuiz } =
    useQuizMetaContext();
  const { mode } = useConfig();

  const slide = usePresentationSlideContext();
  const staticContent = slide.staticContent as LeaderboardStaticContent;

  const timeBasedScoring = leaderboardHasTimeBasedScoringBasedOnPreviousQuiz;

  if (mode !== 'live') {
    return (
      <ViewOnlyPresentationDataHandler
        timeBasedScoring={timeBasedScoring}
        title={slide.title}
        styledTitle={staticContent.styledTitle as Record<string, unknown>}
        label={staticContent.label}
        description={staticContent.additionalDetails}
        textSizeOffset={staticContent.textSizeOffset}
        slidePublicKey={slide.slidePublicKey}
      />
    );
  }

  return (
    <LivePresentationDataHandler
      timeBasedScoring={timeBasedScoring}
      slidePublicKey={slide.slidePublicKey}
      slideAdminKey={slide.slideAdminKey}
      title={slide.title}
      styledTitle={staticContent.styledTitle as Record<string, unknown>}
      label={staticContent.label}
      description={staticContent.additionalDetails}
      textSizeOffset={staticContent.textSizeOffset}
    />
  );
}
